import * as React from "react";

import {
  Tooltip as BaseTooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type TooltipProps = {
  children: React.ReactNode;
  title: string;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayDuration?: number;
  disableHoverableContent?: boolean;
  className?: string;
};

export function Tooltip({
  children,
  title,
  side = "top",
  align = "center",
  delayDuration = 300,
  disableHoverableContent = false,
  className = "",
}: TooltipProps) {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <BaseTooltip disableHoverableContent={disableHoverableContent}>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent
          side={side}
          align={align}
          className={className}
        >
          <p className="text-sm font-medium">{title}</p>
        </TooltipContent>
      </BaseTooltip>
    </TooltipProvider>
  );
}
